import type { SubscriptionTier } from "@prisma/client";

export const PLANS = [
  {
    name: "Free",
    tier: "FREE" as SubscriptionTier,
    price: 0,
    priceAnnual: 0,
    description: "Perfect for trying out Stashds",
    features: [
      "1 Instagram account",
      "5GB storage",
      "Manual story downloads",
      "7-day story history",
    ],
    limitations: [
      "No scheduled archival",
      "No bulk downloads",
      "Limited support",
    ],
    cta: "Get Started",
    popular: false,
  },
  {
    name: "Plus",
    tier: "PLUS" as SubscriptionTier,
    price: 10,
    priceAnnual: 100,
    description: "For power users who want more",
    features: [
      "3 Instagram accounts",
      "50GB storage",
      "Scheduled auto-archival",
      "Bulk downloads",
      "30-day story history",
      "Priority support",
    ],
    limitations: [],
    cta: "Upgrade to Plus",
    popular: true,
    priceId: {
      monthly: "PLUS_MONTHLY",
      annual: "PLUS_ANNUAL",
    },
  },
  {
    name: "Pro",
    tier: "PRO" as SubscriptionTier,
    price: 20,
    priceAnnual: 200,
    description: "For professionals and teams",
    features: [
      "10 Instagram accounts",
      "Unlimited storage",
      "API access",
      "Unlimited story history",
      "Advanced analytics",
      "Team collaboration",
      "White-label exports",
      "24/7 priority support",
    ],
    limitations: [],
    cta: "Go Pro",
    popular: false,
    priceId: {
      monthly: "PRO_MONTHLY",
      annual: "PRO_ANNUAL",
    },
  },
];

export function getPlanByTier(tier: SubscriptionTier) {
  return PLANS.find((plan) => plan.tier === tier) || PLANS[0];
}
